import { EndpointSetting } from "@/constants/app/type";
import { EsimState } from "../types";

export const callbackEsimCatalogPublicFilters: EndpointSetting["caller"] = (
  state: EsimState,
  action,
) => {
  const payload = action.payload ?? {};
  state.esim_catalog_public_filters.data.data = Array.isArray(payload.data) ? payload.data : [];
  state.esim_catalog_public_filters.data.validity = Array.isArray(payload.validity) ? payload.validity : [];
  state.esim_catalog_public_filters.data.parentGroupName = Array.isArray(payload.parentGroupName)
    ? payload.parentGroupName
    : [];
};
